import { observer } from 'mobx-react-lite';
import type { PropsWithChildren } from 'react';
import React from 'react';

import type { RootStore } from './root-store';
import { RootStoreContext } from './root-store-context';

interface Props extends PropsWithChildren<object> {
  store: RootStore;
}

export const RootStoreProvider = observer(function RootStoreProvider({ children, store }: Props) {
  return <RootStoreContext.Provider value={store}>{children}</RootStoreContext.Provider>;
});
